import Breadcrumb from "../../../components/admin/layouts/Breadcrumb/Breadcrumb";
import Container from "../../../components/admin/layouts/Container/Container";
import Header, { HeaderLeft, HeaderRight } from "../../../components/admin/layouts/Header/Header";
import PageWrapper from "../../../components/admin/layouts/PageWrapper/PageWrapper";
import Subheader, {
  SubheaderLeft,
  SubheaderRight,
  SubheaderSeparator,
} from "../../../components/admin/layouts/Subheader/Subheader";
import DefaultHeaderRightCommon from "../../../templates/layouts/Headers/_common/DefaultHeaderRight.common";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "../../../components/ui/Button";
import Card, { CardBody, CardHeader, CardHeaderChild, CardTitle } from "../../../components/ui/Card";
import Label from "../../../components/ui/Label";
import Input from "../../../components/form/Input";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import { Google_map_Key } from "../../../api/url";
import { getLocationsById, getLocationsType, saveLocation } from "../../../services/locationService";
import GoogleMapReact from "google-map-react";
import { Map, InfoWindow, Marker } from "google-maps-react";
// import { useMsal } from "@azure/msal-react"; // Azure B2C - temporarily disabled

const defaultProps = {
  center: {
    lat: 10.99835602,
    lng: 77.01502627,
  },
  zoom: 11,
};

const AnyReactComponent = ({ text }) => <div>{text}</div>;
const AddLocation = () => {
  // const { instance, accounts } = useMsal(); // Azure B2C - temporarily disabled
  const location = useLocation();
  const editLocationInfo = location?.state?.editLocationInfo;
  const [addMachineLoader, setAddMachineLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [locationTypeList, setLocationTypeList] = useState([]);
  const [isCompanySelect, setIsCompanySelect] = useState({
    isSelected: false,
    CompanyId: null,
  });

  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData"))
    : null;

  const inputRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      All: "",
      CompanyName: "",
      Address1: "",
      Address2: "",
      PostalCode: "",
      Province: "",
      Country: "",
      City: "",
      locationOptions: [],
      LocationTypesJson: "",
      LocationTypes: [],
      Latitude: 0.0,
      Longitude: 0.0,
      LocationName: "",
      LocationTypesCount: 0,
      Comment: "",
      lat: 0.0,
      lng: 0.0,
      check: false,
      ShowSalesTaxModal: false,
    },
    validationSchema: Yup.object({
      Address1: Yup.string().required("Address is required"),
      City: Yup.string().required("City is required"),
      Province: Yup.string().required("Province is required"),
      PostalCode: Yup.string().required("Postal Code is required"),
      lat: Yup.number()
        .typeError("lat is required")
        .required("lat is required")
        .notOneOf([0], "lat is required"),
      lng: Yup.number()
        .typeError("lng is required")
        .required("lng is required")
        .notOneOf([0], "lng is required"),
    }),
    onSubmit: (values) => {
      handleSaveLocation(values);
    },
  });

  useEffect(() => {
    if (editLocationInfo?.LocationId) {
      getLocationInfoById(editLocationInfo?.LocationId);
    }
  }, []);

  useEffect(() => {
    handleLocationType();
  }, []);

  const defaultLat = formik.values.lat || 0;
  const defaultLng = formik.values.lng || 0;

  const handleLocationType = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getLocationsType(header)
      .then((res) => {
        setIsLoading(false);
        setLocationTypeList(res.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const getLocationInfoById = (locationId) => {
    setIsLoading(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getLocationsById(locationId, header)
      .then((res) => {
        setIsLoading(false);
        formik.setValues({
          All: res.data?.All,
          CompanyName: res.data?.CompanyName,
          Address1: res.data?.Address1,
          Address2: res.data?.Address2,
          PostalCode: res.data?.PostalCode,
          Province: res.data?.Province,
          Country: res.data?.Country,
          City: res.data?.City,
          locationOptions: res.data?.locationOptions,
          LocationTypesJson: res.data?.LocationTypesJson,
          LocationTypes:
            res.data?.LocationTypes ??
            (res.data?.LocationTypesJson ? JSON.parse(res.data.LocationTypesJson) : []),
          Latitude: res.data?.Latitude,
          Longitude: res.data?.Longitude,
          LocationName: res.data?.LocationName,
          LocationTypesCount: res.data?.LocationTypesCount,
          Comment: res.data?.Comment,
          lat: res.data?.lat || res.data?.Latitude,
          lng: res.data?.lng || res.data?.Longitude,
          check: res.data?.check,
          ShowSalesTaxModal: res.data?.ShowSalesTaxModal,
        });
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  const handlePlaceSelect = (place, formik) => {
    const addressComponents = place?.address_components || [];

    const getComponent = (types) => {
      const component = addressComponents.find((comp) => comp.types.some((type) => types.includes(type)));

      return component ? component.long_name : "";
    };
    formik.setFieldValue(
      "location",
      `${place?.formatted_address} ${getComponent(["sublocality", "neighborhood"])} ${getComponent([
        "locality",
        "administrative_area_level_2",
      ])} ${getComponent(["administrative_area_level_1"])} ${getComponent(["country"])}` || formik.values.address1
    );
    formik.setFieldValue("Address1", place?.formatted_address || formik.values.address1);
    formik.setFieldValue("Address2", getComponent(["sublocality", "neighborhood"]) || "");
    formik.setFieldValue("City", getComponent(["locality", "administrative_area_level_2"]));
    formik.setFieldValue("Province", getComponent(["administrative_area_level_1"]));
    formik.setFieldValue("Country", getComponent(["country"]));
    formik.setFieldValue("PostalCode", getComponent(["postal_code"]));
    formik.setFieldValue("lat", place?.geometry?.location?.lat());
    formik.setFieldValue("lng", place?.geometry?.location?.lng());
  };

  const handleSaveLocation = (value) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    let payload = {
      ...value,
      center: { lat: value?.lat, lng: value?.lng },
      Latitude: value?.lat,
      Longitude: value?.lng,
      LocationTypesCount: value?.LocationTypes.length || 0,
      LocationTypesJson: JSON.stringify(value?.LocationTypes),
      CompanyId: azureUserInfo?.CompanyId,
      DisplayName: `${value?.Address1} ${value?.Address2} ${value?.City}, ${value?.Province}, ${value?.PostalCode}, ${value?.Country}`,
    };

    if (editLocationInfo?.LocationId) {
      payload = {
        ...payload,
        LocationId: editLocationInfo.LocationId,
      };
    }

    saveLocation(payload, header)
      .then((res) => {
        setAddMachineLoader(false);
        getLocationInfoById(res.data.LocationId);
        if (editLocationInfo?.LocationId) {
          toast.success("Location edited successfully.");
        } else {
          toast.success("Location added successfully.");
        }
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const onMapClick = (mapProps, map, clickEvent) => {
    const lat = clickEvent.latLng.lat();
    const lng = clickEvent.latLng.lng();

    const geocoder = new window.google.maps.Geocoder();

    geocoder.geocode({ location: { lat, lng } }, (results, status) => {
      if (status === "OK" && results[0]) {
        const addressComponents = results[0].address_components;

        const addressDetails = {
          Address1: results[0].formatted_address,
          Address2: "", // Can be parsed further if required
          PostalCode: getAddressComponent(addressComponents, "postal_code"),
          Province: getAddressComponent(addressComponents, "administrative_area_level_1"),
          Country: getAddressComponent(addressComponents, "country"),
          City: getAddressComponent(addressComponents, "locality"),
          Lat: lat,
          Lng: lng,
        };

        formik.setFieldValue("Address1", results[0].formatted_address);
        formik.setFieldValue("Address2", "");
        formik.setFieldValue("City", getAddressComponent(addressComponents, "locality"));
        formik.setFieldValue("Province", getAddressComponent(addressComponents, "administrative_area_level_1"));
        formik.setFieldValue("Country", getAddressComponent(addressComponents, "country"));
        formik.setFieldValue("PostalCode", getAddressComponent(addressComponents, "postal_code"));
        formik.setFieldValue("lat", lat);
        formik.setFieldValue("lng", lng);
      } else {
        console.error("Geocoder failed due to:", status);
      }
    });
  };

  // Helper function to extract address components
  const getAddressComponent = (components, type) => {
    const component = components.find((comp) => comp.types.includes(type));
    return component ? component.long_name : "";
  };

  return (
    <>
      <Header>
        <HeaderLeft>
          <Breadcrumb path="Paving Market / Location Info" currentPage="Location" />
        </HeaderLeft>
        <HeaderRight>
          <DefaultHeaderRightCommon />
        </HeaderRight>
      </Header>

      <PageWrapper name="Location Info">
        <Subheader>
          <SubheaderLeft>
            <Link to={`/admin/locations`}>
              <Button icon="HeroArrowLeft" className="!px-0">
                Back to List
              </Button>
            </Link>
            <SubheaderSeparator />
            {editLocationInfo?.LocationId ? "Edit Location" : "Add Location"}
          </SubheaderLeft>
          <SubheaderRight>
            <Button variant="solid" onClick={() => formik.submitForm()}>
              Save
            </Button>
          </SubheaderRight>
        </Subheader>

        <Container>
          {isLoading || addMachineLoader ? (
            <div className="fixed w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0  right-0">
              <span class="loader"></span>
            </div>
          ) : null}
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12">
              <h1 className="my-4 font-bold uppercase">LIST YOUR Location</h1>
            </div>
            <div className="col-span-12">
              <div className="grid grid-cols-12 gap-4">
                <div className="col-span-12">
                  <Card>
                    <CardHeader>
                      <CardHeaderChild>
                        <CardTitle>Location</CardTitle>
                      </CardHeaderChild>
                    </CardHeader>
                    <CardBody>
                      <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-6">
                          <Label htmlFor="id">Address 1</Label>

                          <GooglePlacesAutocomplete
                            apiKey={Google_map_Key}
                            onPlaceSelected={(place) => handlePlaceSelect(place, formik)}
                            onChange={(e) => {
                              formik.setValues({
                                ...formik.values,
                                Address1: e.target.value,
                              });
                            }}
                            options={{
                              types: ["address"],
                            }}
                            value={formik.values.Address1}
                            disabled={isCompanySelect.isSelected}
                            className={`w-full appearance-none outline-0 text-black dark:text-white disabled:!opacity-25 transition-all duration-300 ease-in-out border-2 border-zinc-100 dark:border-zinc-800 bg-zinc-100 dark:bg-zinc-800 hover:border-blue-500 dark:hover:border-blue-500 disabled:!border-zinc-500 focus:border-zinc-300 dark:focus:border-zinc-800 focus:bg-transparent dark:focus:bg-transparent px-1.5 py-1.5 text-base rounded-lg`}
                          />
                          {formik.touched.Address1 && formik.errors.Address1 ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Address1}</p>
                          ) : null}
                        </div>
                        <div className="col-span-6">
                          <Label htmlFor="id">Address2</Label>
                          <Input
                            type="text"
                            name="Address2"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.Address2}
                            placeholder="Enter here"
                          />
                          {formik.touched.Address2 && formik.errors.Address2 ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Address2}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">City</Label>
                          <Input
                            type="text"
                            name="City"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.City}
                            placeholder="Enter here"
                          />
                          {formik.touched.City && formik.errors.City ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.City}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">State/Province</Label>
                          <Input
                            type="text"
                            name="Province"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.Province}
                            placeholder="Enter here"
                          />
                          {formik.touched.Province && formik.errors.Province ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.Province}</p>
                          ) : null}
                        </div>
                        <div className="col-span-4">
                          <Label htmlFor="id">Zip/Postal Code</Label>
                          <Input
                            type="text"
                            name="PostalCode"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.PostalCode}
                            placeholder="Enter here"
                          />
                          {formik.touched.PostalCode && formik.errors.PostalCode ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.PostalCode}</p>
                          ) : null}
                        </div>
                        <div className="col-span-6">
                          <Label htmlFor="id">Longitude</Label>
                          <Input
                            type="text"
                            name="lng"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lng}
                            placeholder="Enter here"
                          />
                          {formik.touched.lng && formik.errors.lng ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.lng}</p>
                          ) : null}
                        </div>
                        <div className="col-span-6">
                          <Label htmlFor="id">Latitude</Label>
                          <Input
                            type="text"
                            name="lat"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lat}
                            placeholder="Enter here"
                          />
                          {formik.touched.lat && formik.errors.lat ? (
                            <p className="text-red-400 mt-1 text-[14px]">{formik.errors.lat}</p>
                          ) : null}
                        </div>
                        <div className="col-span-12">
                          <div className="flex items-center justify-start">
                            <Label htmlFor="id" class="mb-[0px] w-auto mr-[30px]">
                              Location Types :
                            </Label>
                            <div className="flex items-center justify-start">
                              {" "}
                              {locationTypeList?.map((item) => {
                                const isChecked = formik.values?.LocationTypes?.includes(item.LocationTypeId);
                                return (
                                  <div className="flex items-center justify-center mr-[10px]">
                                    <input
                                      type="checkbox"
                                      id={`locationType-${item.LocationTypeId}`}
                                      className="mr-2"
                                      checked={isChecked}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          // Add the ID to LocationTypes array
                                          formik.setFieldValue("LocationTypes", [
                                            ...formik.values.LocationTypes,
                                            item.LocationTypeId,
                                          ]);
                                        } else {
                                          // Remove the ID from LocationTypes array
                                          formik.setFieldValue(
                                            "LocationTypes",
                                            formik.values.LocationTypes.filter(
                                              (typeId) => typeId !== item.LocationTypeId
                                            )
                                          );
                                        }
                                      }}
                                    />
                                    <Label htmlFor="id" class="mb-[0px]">
                                      {item.LocationTypeName}
                                    </Label>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>

                <div className="col-span-12">
                  <Card>
                    <CardHeader>
                      <CardHeaderChild>
                        <CardTitle>Display Name</CardTitle>
                        <Label>
                          {`${formik.values?.Address1} ${formik.values?.Address2} ${formik.values?.City}, ${formik.values?.Province}, $
                          {formik.values?.PostalCode}, ${formik.values?.Country}`}
                        </Label>
                      </CardHeaderChild>
                    </CardHeader>
                    <CardBody>
                      <div className="h-[50vh]">
                        <div
                          style={{
                            position: "relative",
                            alignItem: "center",
                            height: "100%",
                            width: "100%",
                          }}
                        >
                          <div
                            className="flex"
                            style={{
                              position: "relative",
                              maxWidth: "500px",
                              width: "100%",
                              alignItem: "stretch",
                              display: "flex",
                            }}
                          ></div>
                          <Map
                            google={window.google}
                            zoom={5}
                            center={{ lat: defaultLat, lng: defaultLng }}
                            onClick={onMapClick}
                          >
                            <Marker
                              key={`${defaultLat}-${defaultLng}`}
                              position={{ lat: defaultLat, lng: defaultLng }}
                            />
                          </Map>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </PageWrapper>
    </>
  );
};
export default AddLocation;
